import { Controller } from "@hotwired/stimulus"

// Intercepts a form action: validates, opens an embedded ModalComponent via
// client-modal on the same element, then submits on confirm.
export default class extends Controller {
  static targets = ["submit", "trigger"]

  connect() {
    this.submitEndBound = this.resetTriggerLoading.bind(this)
    this.element.addEventListener("turbo:submit-end", this.submitEndBound)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.submitEndBound)
  }

  prompt(event) {
    event.preventDefault()

    if (!this.element.checkValidity()) {
      this.element.reportValidity()
      return
    }

    this.clientModal?.showModal()
  }

  confirm(event) {
    event.preventDefault()
    this.clientModal?.hideModal()
    this.setTriggerLoading()
    this.submitTarget.click()
  }

  close(event) {
    event?.preventDefault()
    this.clientModal?.hideModal()
  }

  get clientModal() {
    return this.application.getControllerForElementAndIdentifier(this.element, "client-modal")
  }

  setTriggerLoading() {
    if (!this.hasTriggerTarget) return

    const button = this.triggerTarget
    const labelElement = button.querySelector("[data-button-label]") || button.querySelector("span")

    if (labelElement && !this.originalTriggerLabel) {
      this.originalTriggerLabel = labelElement.textContent
    }

    button.classList.add("opacity-50", "cursor-wait", "pointer-events-none")
    button.setAttribute("aria-disabled", "true")

    if (labelElement) {
      labelElement.textContent = button.dataset.loadingLabel || "Cargando..."
    }
  }

  resetTriggerLoading(event) {
    if (!this.hasTriggerTarget) return
    if (event?.detail && !event.detail.success) {
      this.clearTriggerLoading()
    }
  }

  clearTriggerLoading() {
    const button = this.triggerTarget
    const labelElement = button.querySelector("[data-button-label]") || button.querySelector("span")

    button.classList.remove("opacity-50", "cursor-wait", "pointer-events-none")
    button.removeAttribute("aria-disabled")

    if (labelElement && this.originalTriggerLabel) {
      labelElement.textContent = this.originalTriggerLabel
    }
  }
}
